import React, { useContext, useEffect, useState } from "react";
import { TranslatorContext } from "../../context/Translator";
import { Link } from "react-router-dom";
import PageLayout from "../../layouts/PageLayout";
import axios from "axios";
import { BASE_URL, TOKEN, CURRENT_IP } from "../../helper/BASE_URL";
import { Row, Col, Dropdown } from "react-bootstrap";

export default function Directs() {
  const [data, setData] = useState([]);
  const [selectedValue, setSelectedValue] = useState(null);
  const [setshowTable, setSetshowTable] = useState([]);

  const { t } = useContext(TranslatorContext);

  useEffect(() => {
    Get_Data();
  }, []);

  const Get_Data = () => {
    const getDta = localStorage.getItem("jwt");
    const parseIT = JSON.parse(getDta);

    try {
      axios
        .post(
          BASE_URL + "get_bounty_tickets.php",
          {
            userid: parseIT.reg_em,
            token: parseIT.boss_token,
            ip_addr: window.localStorage.getItem('bpipos')?window.localStorage.getItem('bpipos'):'224.234.50.218',
            bounty_no: "1",
          },
          {
            headers: {
              ClientKey: TOKEN,
            },
          }
        )
        .then((acc) => {
          setData(acc.data.data.bounty_tickets_list);
        })
        .catch((err) => {});
    } catch (error) {}
  };

  const handleChange = (e) => {
    setSelectedValue(e.target.value);

    let name = e.target.value;

    const getDta = localStorage.getItem("jwt");
    const parseIT = JSON.parse(getDta);

    try {
      axios
        .post(
          BASE_URL + "get_bounty_ticket_wise_pool_log.php",
          {
            userid: parseIT.reg_em,
            token: parseIT.boss_token,
            ip_addr: window.localStorage.getItem('bpipos')?window.localStorage.getItem('bpipos'):'224.234.50.218',
            bounty_no: "1",
            bounty_ticket: name,
          },
          {
            headers: {
              ClientKey: TOKEN,
            },
          }
        )
        .then((acc) => {
          //
          // setSetshowTable(acc.data.data.bounty_pool_list[0].position_fill_count);

          let obj = acc.data.data.bounty_pool_list[0].position_fill_count[0];

          const result = [];
          for (let i = 1; i <= 9; i++) {
            const level = `L${i}`;
            const amount = `${level}_amount`;

            result.push({
              key1: obj[level],
              key2: obj[amount],
            });
          }

          setSetshowTable(result);
        })
        .catch((err) => {});
    } catch (error) {}
  };

  return (
    <PageLayout>
      <div className="mc-card">
        <div className="mc-breadcrumb">
          <h3 className="mc-breadcrumb-title">{t("Bounty Pool")}</h3>
          <ul className="mc-breadcrumb-list">
            <li className="mc-breadcrumb-item">
              <Link to="#" className="mc-breadcrumb-link">
                {t("home")}
              </Link>
            </li>
            <li className="mc-breadcrumb-item">{t("Bounty Pool")}</li>
          </ul>
        </div>
      </div>

      <div className="select-container mb-4">
        <select
          value={selectedValue}
          style={{
            width: "50%",
            padding: 10,
            backgroundColor: "#3B81F6",
            color: "white",
            fontWeight: "bolder",
          }}
          onChange={handleChange}
          className="select"
        >
          <option value={null}>Select Any Ticket</option>

          {data.map((hit, index) => {
            return (
              <option key={index} value={hit}>
                {hit}
              </option>
            );
          })}
        </select>
      </div>

      {selectedValue && (
        <div className="mc-card p-sm-5">
          <table className="mc-table">
            <thead className="mc-table-head">
              <tr>
                {/* <th>S.N.</th> */}
                <th>Level </th>
                <th>Members</th>
                <th>Reward</th>
                <th>Total USD</th>
              </tr>
            </thead>
            <tbody className="mc-table-body">
              {setshowTable.map((hit, index) => {
                return (
                  <tr key={index}>
                    {/* <td>{index + 1}</td> */}
                    <td>Level {index + 1}</td>
                    <td>{hit.key1}</td>
                    <td>{hit.key1}</td>
                    <td>$ {hit.key2}</td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        </div>
      )}
    </PageLayout>
  );
}
